export const INIT_FORM_NON_BUSINESS = {
    date: -1,
    reason: ""
};
export const ERRORS_FOR_ACTION = {
    SCHEDULES_REGISTER: {
        REGISTERED_PREV: "HORARIO_REGISTRADO_PREV"
    },
    SCHEDULES_DELETION: {
        EXIST_RESERVATIONS: "EXISTEN_RESERVAS"
    },
    NON_BUSINESS_DAY_REGISTER: {
        REGISTERED_PREV: "DIA_NO_HABIL_REGISTRADO_PREV"
    }
}
export const PERIOD_DATE_FIELD = { 
    min: [1, 1, 1], max: [3000, 1, 1]
};